import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';
import { Signature, ToSign } from './types';

export async function postToSign(data: ToSign) {
  try {
    const response = await api().post('/docusign/signer', {
      meetingId: data.meetingId,
      returnUrl: data.returnUrl,
      email: data.email,
      name: data.name,
      clientUserId: data.clientUserId,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.log(error);
    return null;
  }
}

export async function getSignatureByMeetingIdRequest(meetingId: string) {
  try {
    const response = await api().get(`/signatures/meeting/${meetingId}`);

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSignaturesSignedByCompanyId(
  userId: string,
  companyId: string,
  search: string,
  page: string,
) {
  try {
    const response = await api().get(`/signatures/signed/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        search,
        page,
        size: '1000',
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSignaturesUnsignedByCompanyid(
  userId: string,
  companyId: string,
  search: string,
  page: string,
) {
  try {
    const response = await api().get(`/signatures/unsigned/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        search,
        page,
        size: '1000',
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSignaturesById(id: string) {
  try {
    const response = await api().get(`/signatures/${id}`);

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSignaturesByCompanyId(companyId: string) {
  try {
    const response = await api().get(`/signatures/company/${companyId}`);

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSignaturesUnsignedByDashboard(companyId: string) {
  try {
    const response = await api().get(
      `/signatures/unsigned/company/${companyId}`,
    );

    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function updateSignatureRequest(
  id: string,
  updateSignature: Signature,
) {
  try {
    const response = await api().patch(`/signatures/${id}`, updateSignature);

    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}
